// src/belediye/components/utils/PageHeader.js
//
// PAYLAŞILAN sayfa başlık barı — TEK KAYNAK. Tüm liste/detay sayfaları buradan
// aynı yapıyı kullanır: sticky başlık + araç çubuğu (sol sekme/rozet + sağ araçlar)
// + alt kenarda gri sınır çizgisi (tema değişkenine bağlı).
//
// Renkler theme.css değişkenlerine bağlıdır (--color-*), her belediyenin temasına
// otomatik uyar; sabit/hardcode renk yoktur.
//
// ── FAZ-89 — TELEFONDA AYRI BİR AĞAÇ ────────────────────────────────────────
// Telefonda üç şey değişir:
//   1. <h2> sayfa başlığı ÇİZİLMEZ (+44px). "Neredeyim" bilgisi alt bardaki
//      seçili yuvadan, çekmecedeki etkin maddeden ve seçili çipten okunur.
//      Bilgi popover'ı kaybolmaz — araç satırının sonuna geçer.
//   2. Sekmeler 2×2 ızgaradan tek sıra yatay kayan ÇİP ŞERİDİNE döner.
//   3. Kaydırınca ARAÇLAR KAYAR, ÇİP ŞERİDİ SABİT KALIR (K-9).
//
// (3) için DOM'un değişmesi şart: `position: sticky` yalnız KAPSAYICISI
// ekrandayken yapışır. Çip şeridi araç çubuğunun içinde bırakılsaydı, kısa
// olan araç çubuğu ekrandan çıkar çıkmaz şerit de onunla giderdi. Bu yüzden
// telefonda araç satırı yapışkan kabın DIŞINA alınır; kap yalnız şeridi taşır.
//
// Props:
//   title        — başlık metni (h2)
//   infoTitle    — InfoPopover başlığı
//   infoContent  — InfoPopover içeriği. Verilirse: MOBİLDE ikon,
//                  MASAÜSTÜNDE araç çubuğunda etiketli açılır — otomatik.
//   tabs         — araç çubuğu SOL bölge (sekmeler / rozet vb.)
//   tabsClassName— sol bölgeye ek sınıf (ör. mobilde gizleme)
//   children     — araç çubuğu SAĞ bölge (arama, filtre, buton…) — bilgi otomatik eklenir
//   belowToolbar — araç çubuğunun ALTINDA, sticky İÇİNDE render (ör. kolon başlıkları)
//   stickyRef    — sticky öğeye ref (ör. yükseklik ölçümü). Telefonda ÇİP
//                  ŞERİDİNE bağlanır — ölçülmesi gereken yapışkan parça odur.
//   className    — sticky öğeye ek sınıf

import React, { useRef } from "react";
import InfoPopover from "./InfoPopover";
// FAZ-89: katman tek kaynaktan (bkz. belediye/olcu.js)
import useKatman from "../../hooks/useKatman";
// FAZ-92: şeritte "devamı var" ipucu + sayfa adını navbara bildirme
import useCipTasma from "../../hooks/useCipTasma";
import { useNavbarBasligiAyarla } from "../NavbarBaslikContext";

// Ortak başlık/araç-çubuğu stilleri (.applications-*) burada garanti altına alınır
import "../../pages/ApplicationsPage.css";
import "../../pages/ApplicationsPage.mobile.css";

export default function PageHeader({
  title,
  infoTitle = "Bilgi",
  infoContent = null,
  infoWide = false,
  tabs = null,
  tabsClassName = "",
  children = null,
  belowToolbar = null,
  stickyRef = null,
  className = "",
}) {
  const katmanAdi = useKatman();
  const cipKapRef = useRef(null);
  useCipTasma(cipKapRef);

  /* FAZ-92 — SAYFA ADI NAVBARA ÇIKAR.
     Kullanıcı: "anasayfadayken yukarıda Kırıkhan İletişim Merkezi yazıyor;
     başvurular sayfasına girince orada Başvurular yazsın."
     FAZ-89'da telefonda <h2> kaldırılmıştı; adı taşıyan yer artık navbar.
     `tur: "sayfa"` KRİTİK: navbar sol yuvayı geri okuna yalnız `tur:"kayit"`
     olduğunda çevirir — aksi hâlde her liste sayfasında geri oku belirirdi. */
  useNavbarBasligiAyarla(
    katmanAdi === "telefon" && title ? { ad: title, tur: "sayfa" } : null,
  );

  const bilgiIkonu = infoContent ? (
    <div className="applications-head-info-mobile">
      <InfoPopover iconOnly wide={infoWide} title={infoTitle}>
        {infoContent}
      </InfoPopover>
    </div>
  ) : null;

  /* ── TELEFON + TABLET ────────────────────────────────────────────────────
     FAZ-98 / T-8+T-9 — TABLET DE BU AĞACI KULLANIR.

     FAZ-89'da K-12 "tablet = masaüstü" diyordu. Kullanıcı 2026-08-02'de bunu
     ölçtü ve geri aldı:

       "iPad Pro'da başvurular sayfasında… web'de sekmeler bir tarafta, arama /
        filtreleme / bilgi bir tarafta ya — burada sekmeler üste çıkmış, arama
        filtreleme aşağı gelmiş. Burası mobille de uyuşmuyor, çünkü mobildeyken
        arama filtreleme bilgi en üstte kalıyor, sonra sekme altta kalıyor, sonra
        sayfa kayınca sekmeler yukarıda kalıyor, filtreleme kayboluyor. Aynı
        mantığa getirebilirsin."

     Sebep: masaüstü ağacı sekmeleri ve araçları TEK SATIRA yan yana koyuyor
     (`.applications-toolbar`). 600–1024px'te o satır sığmıyor ve sarıyor —
     "Tamamlanan" sekmesi arama kutusunun altına düşüyordu. Sarma yerine
     telefonun düzeni: araçlar bir satır (kayar), sekmeler tek sıra kayan çip
     şeridi (yapışır).

     TABLETTE TEK FARK — <h2> DURUYOR:
       • Telefonda başlık navbara taşınmıştı (FAZ-92); tablet navbarı artık
         masaüstü navbarı (FAZ-98/T-1) ve orada sistem adı yazıyor, sayfa adı
         yazacak yuva yok. Başlık sayfada kalmazsa hiçbir yerde kalmaz.
       • Bu yüzden `useNavbarBasligiAyarla` de yalnız telefonda yazıyor
         (yukarıda), tablette navbara hiçbir şey bildirilmiyor.
     ─────────────────────────────────────────────────────────────────────── */
  const telefon = katmanAdi === "telefon";
  if (telefon || katmanAdi === "tablet") {
    /* FAZ-99 / Y-2 — BOŞ ŞERİT ÇİZİLMEZ; SEKME YOKSA ARAÇLAR YAPIŞIR.

       Kullanıcı (2026-08-02): "sekme olmayan sayfalarda orada başka bir şeyler
       olsun. Mesela raporlar sayfasında yukarıda boşuna şerit duruyor; bunu
       kaldıralım ya da oraya sıfırla / yenile / bilgi butonlarını falan
       ekleyelim. Diğer sayfalarda da bu şekilde: bu şeride ekleyecek bir şey
       yoksa ya kaldıralım ya da gerekli bir şeyler ekleyelim — arama,
       filtreleme, bilgi gibi butonlar."

       Kural üç hâlli:
         tabs VAR   → araçlar üstte kayar, şerit ÇİPLERİ taşır (K-9: çipler
                      gezinmedir, arama ayardır — biri kalır, öteki kayar).
         tabs YOK   → şeridin taşıyacağı gezinme yok; ARAÇLAR şeride girer ve
                      yapışan şey onlar olur. Raporlar sayfası böylece
                      "Sıfırla · Yenile · Bilgi" taşıyan bir şerit alır.
         ikisi de YOK → şerit HİÇ çizilmez. Eskiden boş bir kap + alt kenar
                      çizgisi kalıyordu: hiçbir şey söylemeyen bir kat. */
    const seritCipli = Boolean(tabs);
    const araclar = children || bilgiIkonu ? (
      <div className="applications-araclar-mobil">
        {children}
        {bilgiIkonu}
      </div>
    ) : null;
    const seritVar = seritCipli || Boolean(belowToolbar) || Boolean(araclar);

    return (
      <>
        {/* Tablette sayfa adı: kaydırınca araçlarla birlikte kayar, çünkü
            "neredeyim" bilgisini yapışkan şeritteki etkin çip zaten taşıyor. */}
        {!telefon && (
          <div className="applications-header">
            <h2 className="applications-title">{title}</h2>
          </div>
        )}

        {/* (1) ARAÇLAR — yalnız ÇİPLİ şeritte dışarıda kalır ve kayar. */}
        {seritCipli ? araclar : null}

        {/* (2) YAPIŞKAN ŞERİT — içeriği yukarıdaki kurala göre. */}
        {seritVar && (
          <div
            ref={stickyRef}
            className={[
              "applications-sticky",
              "applications-sticky--cip",
              seritCipli ? "" : "applications-sticky--arac",
              className,
            ]
              .filter(Boolean)
              .join(" ")}
            data-katman={katmanAdi}
          >
            {seritCipli ? (
              <div
                ref={cipKapRef}
                className={["applications-tabs-kap", tabsClassName]
                  .filter(Boolean)
                  .join(" ")}
                data-tasma="yok"
              >
                {tabs}
              </div>
            ) : (
              araclar
            )}
            {belowToolbar}
          </div>
        )}
      </>
    );
  }

  /* ── MASAÜSTÜ — bugünkü yapı birebir ─────────────────────────────────── */
  return (
    <div
      ref={stickyRef}
      className={`applications-sticky${className ? ` ${className}` : ""}`}
      data-katman={katmanAdi}
    >
      {/* Başlık — MOBİLDE: başlık sol + bilgi ikonu sağ */}
      <div className="applications-header">
        <h2 className="applications-title">{title}</h2>
        {bilgiIkonu}
      </div>

      {/* Araç çubuğu: sol = sekme/rozet, sağ = araçlar (+ masaüstü bilgi) */}
      <div className="applications-toolbar">
        <div
          className={`applications-toolbar-left${
            tabsClassName ? ` ${tabsClassName}` : ""
          }`}
        >
          {tabs}
        </div>

        <div className="applications-tools">
          {children}
          {infoContent ? (
            <div className="applications-head-info-desktop">
              <InfoPopover wide={infoWide} title={infoTitle}>
                {infoContent}
              </InfoPopover>
            </div>
          ) : null}
        </div>
      </div>

      {belowToolbar}
    </div>
  );
}
